<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title border-bottom pb-2"> {{ $t('tasks.modal.chat_notes') }}</h5>

      <!-- Chat and notes card: Chat-->
      <div class="mt-3 mb-3">
        <div class="row" v-if="selectedTask.data_status != 'completed' && selectedTask.status != 'completed'">
          <div class="col-sm-10 chat-box-col-text">
            <b-form-textarea qid="create-s-form-description" v-model="comment" class="chat-box-text" rows="2"
              max-rows="2" :placeholder="$t('tasks.modal.question_to_recipient_label')"></b-form-textarea>
          </div>
          <div class="col-sm-2 chat-box-col-button cursor-pointer">
            <div class="chat-box-button" @click="addCommentSubmit">
              {{ $t('tasks.modal.send_button_label') }}
            </div>
          </div>
        </div>
      </div>

      <div class="form-control scrollable-height-260 pt-3" style="background-color: white;">
        <div v-if="previousComments && previousComments.length">
          <div v-for="(comment, comment_index) in previousComments" class="mt-2 chat-message"
            :key="comment_index">
            <p>
              <span class="cursor-pointer float-right" @click="openDeleteCommentModal(comment)"
                v-if="isCommentOwner(comment) && selectedTask.status != 'completed'" qid="view-p-remove-link">
                <font-awesome-icon icon="trash-alt" />
              </span>
              <Avatar :object="comment.user" size="xs"></Avatar>
              <span class="ml-1">
                {{ comment.user.name }}
              </span>
              {{ $t('system.on') }}
              <span class="text-normal">
                {{ comment.updated_at | formatDateTime }}
              </span>
            </p>
            <div v-if="comment.comment && comment.comment.length > 300">
              <p v-if="comment.expanded" class="text-formatted">{{ comment.comment }}</p>

              <p v-if="!comment.expanded" class="text-formatted">{{ comment.comment | truncate(300) }}</p>

              <div class="text-center mt-3" @click="comment.expanded = !comment.expanded">
                <span class="cursor-pointer" v-if="!comment.expanded">
                  <span class="mr-2">
                    {{ $t('system.view_more') }}
                  </span>
                  <font-awesome-icon icon="chevron-down" />
                </span>
                <span class="cursor-pointer" v-if="comment.expanded">
                  <span class="mr-2">
                    {{ $t('system.view_less') }}
                  </span>
                  <font-awesome-icon icon="chevron-up" />
                </span>
              </div>
            </div>

            <p v-if="comment.comment && comment.comment.length <= 300" class="text-formatted">{{
              comment.comment
            }}</p>
          </div>
        </div>
        <div v-if="!previousComments.length" class="text-center">
          <h5 class="mt-3">
            {{ $t('system.no_results') }}
          </h5>
        </div>
      </div>

      <!-- Chat and notes card: Notes-->
      <b-form-group
        v-if="selectedTask && selectedTask.add_notes && selectedTask.add_notes == 'Optional' || selectedTask.add_notes == 'Mandatory'"
        class="mb-3">
        <label qid="assessment-form-notes-label" style="font-size: medium;" class="mt-3">
          {{ $t('tasks.modal.notes_label') }}
          <span class="text-red" v-if="selectedTask && selectedTask.add_notes == 'Mandatory'">*</span>
        </label>

        <span class="btn section-btn text-success cursor-pointer float-right mt-2" @click="editModeNotes = !editModeNotes"
          v-if="!editModeNotes && selectedTask.status != 'completed'">
          <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
        </span>

        <span class="btn section-btn text-danger cursor-pointer float-right" @click="discardNotes(selectedTask)"
          v-if="editModeNotes && selectedTask.status != 'completed'">
          {{ $t('tasks.modal.discard') }}
        </span>

        <span class="btn section-btn text-success cursor-pointer float-right" @click="updateNotes(selectedTask)"
          v-if="editModeNotes && selectedTask.status != 'completed'">
          {{ $t('tasks.modal.save') }}
        </span>

        <b-form-textarea qid="assessment-form-notes" v-model="taskForm.notes"
          v-if="editModeNotes && selectedTask.status != 'completed'" rows="6" max-rows="6"
          :required="selectedTask.add_notes == 'Mandatory'" :placeholder="$t('tasks.modal.notes_placeholder')"></b-form-textarea>

        <div v-if="!editModeNotes || selectedTask.status == 'completed'" style="margin-top: -20px;">
          <div v-if="taskForm.notes && taskForm.notes.length > 300">
            <p v-if="showFullTextNotes" class="text-formatted">
              {{ taskForm.notes }}
            </p>

            <p v-if="!showFullTextNotes" class="text-formatted">
              {{ taskForm.notes | truncate(300) }}
            </p>

            <div class="text-center mt-3" @click="showFullTextNotes = !showFullTextNotes">
              <span class="cursor-pointer" v-if="!showFullTextNotes">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down" />
              </span>
              <span class="cursor-pointer" v-if="showFullTextNotes">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up" />
              </span>
            </div>
          </div>

          <p v-if="taskForm.notes && taskForm.notes.length <= 300" class="text-formatted">
            {{ taskForm.notes }}
          </p>

          <p v-if="!taskForm.notes" qid="no-results-row-rr" class="text-muted" style="margin-top: 20px;">
            {{ $t('system.no_results') }}
          </p>
        </div>
      </b-form-group>

    </div>
  </div>
</template>


<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModalChatNotesCard',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Avatar
  }
};
</script>
